<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-6 sm:mb-10" v-html="dataLocales.any_content.title">

        </h2>

        <div class="grid grid-cols-12 lg:gap-x-4">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <h3 class="text-xl sm:text-2xl font-semibold mb-3"> {{ post.title }}</h3>
                    <div class="text-base lg:text-lg" v-html="post.description">

                    </div>
                </div>
                <div class="mt-4">
                    <a href="https://app.qrgateway.com/sign-up" target="_blank" rel="nofollow"
                        class="flex items-center gap-2 h-[50px] px-8 w-fit rounded-3xl bg-success text-white drop-shadow-md hover:drop-shadow-xl">{{
                            $t('try_free_now') }}</a>
                </div>
            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/www.png" height="420px" alt="url-to-qr-code" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';


const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: " Difference between static and dynamic QR codes for website URLs",
        data: [
            {
                title: "📌 Static QR code",
                description: " <p>Directly encodes the input website URL into a QR code, which cannot be modified after generation. </p> <p>It cannot track scan volume and is suitable for cases where the website URL does not need to be changed.</p>"
            },
            {
                title: "🌟 Dynamic QR code",
                description: "<p>QRGateway automatically assigns a short URL to redirect to the input target website URL, and generates a QR code for this short URL. </p> <p> Scanning the QR code will immediately redirect to the target website URL and record visitor data. </p> <p>If the target website URL is modified later, the QR code pattern will remain the same because the short URL is unchanged.</p>"
            }
        ]
    },
    {
        locale: "vi",
        title: "Sự khác biệt giữa mã QR tĩnh và động cho địa chỉ website",
        data: [
            {
                title: "📌 Mã QR tĩnh",
                description: "<p>Trực tiếp mã hóa địa chỉ website vào mã QR, sau khi tạo xong không thể sửa đổi. </p> <p>Không thể theo dõi số lượt quét và phù hợp với các trường hợp địa chỉ website không cần thay đổi thường xuyên.</p>"
            },
            {
                title: "🌟 Mã QR động",
                description: "<p>QRGateway tự động cấp một địa chỉ URL ngắn để chuyển hướng đến địa chỉ website đầu vào, và tạo mã QR cho địa chỉ URL ngắn này. </p> <p>Quét mã QR sẽ ngay lập tức chuyển hướng đến địa chỉ website đích và ghi lại dữ liệu khách truy cập. </p> <p>Nếu địa chỉ website đích được thay đổi sau này, mẫu mã QR sẽ vẫn giữ nguyên vì địa chỉ URL ngắn không thay đổi.</p>"
            }
        ]
    },
    {
        locale: "de",
        title: "Unterschied zwischen statischen und dynamischen QR-Codes für Website-URLs",
        data: [
            {
                title: "📌 Statischer QR-Code",
                description: "<p> Kodiert die Eingangs-Website-URL direkt in einen QR-Code, der nach der Generierung nicht mehr geändert werden kann. </p> <p>Er kann nicht das Scan-Volumen verfolgen und ist für Fälle geeignet, in denen die Website-URL nicht geändert werden muss.</p>"
            },
            {
                title: "🌟 Dynamischer QR-Code",
                description: "<p>QRGateway weist automatisch eine kurze URL zu, die zur Eingangsziel-Website-URL umleitet, und generiert einen QR-Code für diese kurze URL. </p> <p>Das Scannen des QR-Codes leitet sofort zur Ziel-Website-URL weiter und zeichnet Besucherdaten auf. </p> <p>Wenn die Ziel-Website-URL später geändert wird, bleibt das QR-Code-Muster gleich, da die kurze URL unverändert bleibt.</p>"
            }
        ]
    },
    {
        locale: "fr",
        title: "Différence entre les codes QR statiques et dynamiques pour les URL de sites Web",
        data: [
            {
                title: "📌 Code QR statique",
                description: " <p> Encode directement l'URL du site Web en entrée dans un code QR, qui ne peut pas être modifié après la génération. </p> <p> Il ne peut pas suivre le volume de numérisation et convient aux cas où l'URL du site Web n'a pas besoin d'être modifiée. </p>"
            },
            {
                title: "🌟 Code QR dynamique",
                description: "<p> QRGateway attribue automatiquement une URL courte pour rediriger vers l'URL cible du site Web d'entrée, et génère un code QR pour cette URL courte. </p> <p> La numérisation du code QR redirige immédiatement vers l'URL cible du site Web et enregistre les données des visiteurs. </p> <p> Si l'URL du site Web cible est modifiée ultérieurement, le modèle de code QR reste identique car l'URL courte n'a pas changé. </p>"
            }
        ]
    },
    {
        locale: "it",
        title: "Differenza tra codici QR statici e dinamici per gli URL del sito Web",
        data: [
            {
                title: "📌 Codice QR statico",
                description: " <p> Codifica direttamente l'URL del sito Web di input in un codice QR, che non può essere modificato dopo la generazione. </p> <p> Non può tracciare il volume di scansione ed è adatto per i casi in cui l'URL del sito Web non ha bisogno di essere modificato. </p>"
            },
            {
                title: "🌟 Codice QR dinamico",
                description: "<p> QRGateway assegna automaticamente un URL breve per reindirizzare all'URL del sito Web di destinazione di input e genera un codice QR per questo URL breve. </p> <p> La scansione del codice QR reindirizza immediatamente all'URL del sito Web di destinazione e registra i dati dei visitatori. </p> <p> Se l'URL del sito Web di destinazione viene modificato successivamente, il modello del codice QR rimane identico perché l'URL breve non è cambiato. </p>"
            }
        ]
    },
    {
        locale: "es",
        title: " Diferencia entre códigos QR estáticos y dinámicos para URLs de sitios web",
        data: [
            {
                title: "📌 Código QR estático",
                description: " <p>Codifica directamente la URL del sitio web de entrada en un código QR, que no se puede modificar después de la generación. </p> <p>No puede realizar un seguimiento del volumen de escaneo y es adecuado para casos en los que la URL del sitio web no necesita ser modificada.</p>"
            },
            {
                title: "🌟 Código QR dinámico",
                description: "<p>QRGateway asigna automáticamente una URL corta para redirigir a la URL del sitio web de destino de entrada y genera un código QR para esta URL corta. </p> <p> Al escanear el código QR, se redirige inmediatamente a la URL del sitio web de destino y se registra los datos de visita. </p> <p>Si la URL del sitio web de destino se modifica más tarde, el patrón del código QR seguirá siendo el mismo porque la URL corta no ha cambiado.</p>"
            }
        ]
    },
    {
        locale: "pt",
        title: "Diferença entre códigos QR estáticos e dinâmicos para URLs de sites",
        data: [
            {
                title: "📌 Código QR estático",
                description: " <p>Codifica directamente la URL del sitio web de entrada en un código QR, que no se puede modificar después de la generación. </p> <p>No puede realizar un seguimiento del volumen de escaneo y es adecuado para casos en los que la URL del sitio web no necesita cambiarse.</p>"
            },
            {
                title: "🌟 Código QR dinámico",
                description: "<p>QRGateway asigna automáticamente una URL corta para redirigir a la URL del sitio web de destino de entrada y genera un código QR para esta URL corta. </p> <p> Escanear el código QR redirigirá inmediatamente a la URL del sitio web de destino y registrará los datos del visitante. </p> <p>Si la URL del sitio web de destino se modifica más tarde, el patrón del código QR seguirá siendo el mismo porque la URL corta no ha cambiado.</p>"
            }
        ]
    },
    {
        locale: "ja",
        title: "ウェブサイトURLの静的QRコードと動的QRコードの違い",
        data: [
            {
                title: "📌 静的QRコード",
                description: "<p>入力されたウェブサイトURLを直接QRコードにエンコードし、生成後に変更できません。</p> <p>スキャン量を追跡できず、ウェブサイトURLを変更する必要がない場合に適しています。</p>"
            },
            {
                title: "🌟 動的QRコード",
                description: "<p>QRGatewayは、入力されたターゲットウェブサイトURLにリダイレクトするための短縮URLを自動的に割り当て、この短縮URLのQRコードを生成します。</p> <p>QRコードをスキャンすると、すぐにターゲットウェブサイトURLにリダイレクトされ、訪問者データが記録されます。</p> <p>ターゲットウェブサイトURLが後で変更された場合でも、短縮URLが変更されていないため、QRコードのパターンは変わりません。</p>"
            }
        ]
    },
    {
        locale: "zh",
        title: "网站URL的静态QR码和动态QR码的区别",
        data: [
            {
                title: "📌 静态QR码",
                description: "<p>直接将输入的网站URL编码成QR码，生成后无法修改。</p> <p>不能跟踪扫描量，适用于网站URL不需要更改的情况。</p>"
            },
            {
                title: "🌟 动态QR码",
                description: "<p>QRGateway会自动分配一个短网址以重定向到输入的目标网站URL，并生成该短网址的QR码。</p> <p>扫描QR码将立即重定向到目标网站URL并记录访客数据。</p> <p>如果目标网站URL稍后进行修改，则QR码模式将保持不变，因为短网址未更改。</p>"
            }
        ]
    }












])
</script>